// import React from "react";
import React from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useMapContext } from "../../context/map.context";
import { CampaignTableModel } from "../../models/tables.model";
import { BadgeState } from "../../utils/badgeState.util";
import { ExportTable } from "./ExportTable";
import { StringUtil } from "../../utils/string.util";

function getDynamicColumns(tableData, translateFunction) {
  const columnNames = Object.getOwnPropertyNames(tableData[0] || []);

  //DYNAMIC COLUMNS
  const columns = columnNames.map((name) => ({
    name,
    //selector: (row) => [row[name]],
    cell: (row) => <div className="font-weight-bold">{row[name]}</div>,
    sortable: true,
  }));

  //ADDITIONAL ACTION COLUMS
  columns.push({
    name: "ACTION",
    cell: (row) => <Link to={`details/${row[CampaignTableModel.Id]}`}>{translateFunction("general.Details")}</Link>,
    sortable: true,
  });

  return columns;
}

function getStaticColumns(tableData, translateFunction) {

  const isHiddenRedeemed = tableData ? (tableData[CampaignTableModel.RedeemedVouchers] === undefined) : false;

  const ChangeWord = (name) => {
    if(name === "OUTDATED"){
      return "FINISHED"
    }else if(name === "SUSPENDED"){
      return "CANCELED"
    }else{
      return name
    }
  }

  //https://react.spruko.com/spruha/preview/advanceUI/userlist/
  const columns = [
    {
      name: CampaignTableModel.CampaignName,
      grow: 1,
      //selector: (row) => row[CampaignTableModel.CampaignName],
      cell: (row) => <div>{row[CampaignTableModel.CampaignName]}</div>,
      sortable: true,
    },
    {
      name: CampaignTableModel.ValidFrom,
      grow: 1,
      selector: (row) => row[CampaignTableModel.ValidFrom],
      //cell: (row) => <div className="font-weight-bold">{row[CampaignTableModel.ValidFrom]}</div>,
      sortable: true,
    },
    {
      name: CampaignTableModel.ValidTo,
      grow: 1,
      selector: (row) => row[CampaignTableModel.ValidTo],
      //cell: (row) => <div className="font-weight-bold">{row[CampaignTableModel.ValidTo]}</div>,
      sortable: true,
    },
    {
      name: CampaignTableModel.RedeemedVouchers,
      grow: 1,
      selector: (row) => row[CampaignTableModel.RedeemedVouchers],
      //cell: (row) => <div className="font-weight-bold">{row[CampaignTableModel.RedeemedVouchers]}</div>,
      sortable: true,
      omit: isHiddenRedeemed,
    },
    {
      name: CampaignTableModel.IssuedVouchers,
      grow: 1,
      selector: (row) => row[CampaignTableModel.IssuedVouchers],
      //cell: (row) => <div className="font-weight-bold">{row[CampaignTableModel.IssuedVouchers]}</div>,
      sortable: true,
      omit: isHiddenRedeemed,
    },
    {
      name: CampaignTableModel.Scope,
      grow: 1,
      //selector: (row) => row[CampaignTableModel.Scope],
      cell: (row) => <div className="font-weight-bold">{row[CampaignTableModel.Scope]}</div>,
      sortable: true,
    },
    {
      name: CampaignTableModel.State,
      //selector: (row) => [row[name]],
      //selector: (row) => row[CampaignTableModel.State],
      sortable: true,
      //cell: (row) => <div className="align-center">{BadgeState(formatStringFirstLetter(row[CampaignTableModel.State]))}</div>,
      cell: (row) => <div>{BadgeState(ChangeWord(row[CampaignTableModel.State]))}</div>,
    },
    {
      name: translateFunction("general.Action"),
      cell: (row) => <Link to={`../CampaignTools/details/${row[CampaignTableModel.Id]}`}>{translateFunction("general.Details")}</Link>,
      sortable: true,
    },
  ];

  //const hasRedeemedVouchers = tableData[CampaignTableModel.RedeemedVouchers] !== undefined
  //const columnsWithoutRedeemedVouchers = columns.filter(column => column.name !== CampaignTableModel.RedeemedVouchers)

  //console.log("STATIC COLUMNS ", { hasRedeemedVouchers, tableData, columnsWithoutRedeemedVouchers })

  //return hasRedeemedVouchers ? columns : columnsWithoutRedeemedVouchers
  return columns
}

export function CampaignTable({ data, dynamicColumns = false }) {
  const { t: translate } = useTranslation();
  const { onTableDevicesClick } = useMapContext();

  const [firstColumnData] = data //instead of data[0]

  const columns = dynamicColumns ? getDynamicColumns(data, translate) : getStaticColumns(firstColumnData, translate);

  const tableData = {
    columns,
    data,
  };

  return (
    // DataTableExtensions => (AddOn Lib for Search & Export)
    <ExportTable tableData={data}>
      <DataTableExtensions {...tableData} >
        <DataTable
          columns={tableData.columns}
          data={tableData.data}
          defaultSortAsc={false}
          center={true}
          pagination
          highlightOnHover
          onRowClicked={onTableDevicesClick} />
      </DataTableExtensions>
    </ExportTable>
  );
}
